// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__24ykh","list":"PatternAutocomplete_list__2MYlW"};